import { observable, action } from "mobx";

/**
* Event defines model for prelive event
* @typedef Event
* @type {Object}
* @property {id} Sport id
* @property {sortId} Sorting id for the branches inside branch selector element
* @property {eventIds} Collection of event IDs
* @property {name} Name of the Sport
*/

export type SportType = {

    id: string;
    sortId: string;

    eventIds: string[];

    name: string;
}

export class Sport {

    id: string;
    sortId: string;

    @observable eventIds: string[];

    name: string;

    constructor(sportInfo: SportType)
    {
        this.id = sportInfo.id;
        this.sortId = sportInfo.sortId;

        this.eventIds = sportInfo.eventIds;

        this.name = sportInfo.name;
    }

    @action addEventId(eventId: string) {
        this.eventIds.push(eventId);
    }

    @action removeEventId(eventId: string) {
        this.eventIds.forEach((id, i) => id === eventId && this.eventIds.splice(i, 1));
    }
}